/**
 * OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPage
 *
 * Page component for OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPage
 * Path: /ar/docs/core-concepts/patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPatternsARDocScreenView as __OrbDocCoreConceptsPatternsARDocScreenView } from '@/components/traits/OrbDocCoreConceptsPatternsARDocScreenView';
import { OrbDocCoreConceptsPatternsARDocAnalyticsView as __OrbDocCoreConceptsPatternsARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPatternsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPage(_props: OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"أنماط الواجهة","description":"ما يستطيع render-ui رسمه: شجرة من الأنماط المسجّلة مرتبطة بالكيان.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/patterns"},{"locale":"ar","path":"/ar/docs/core-concepts/patterns"},{"locale":"sl","path":"/sl/docs/core-concepts/patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPatternsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPatternsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPatternsAROrbDocCoreConceptsPatternsARPage;
